export const trimHours = (str: 'hh[h]mm' | string) => {
  const MATCH_LEADING_ZERO = /^0{1}([0-9])/
  const MATCH_MINUTES_ZEROS = /0{2}$/

  return str.replace(MATCH_LEADING_ZERO, '$1').replace(MATCH_MINUTES_ZEROS, '')
}
